"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buttons = void 0;
const buttons = exports.buttons = {
    remove: {
        visible: true,
        trigger: true
    }
};
